import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { ExportDashboardState } from './export.state';
import { getters } from './export.getters';
import { mutations } from './export.mutations';
import { actions } from './export.actions';

VueXHelper.setStoreModule(Module.DASHBOARD_EXPORT, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new ExportDashboardState(),
  getters,
  mutations,
  actions,
};
